export default __webpack_public_path__ + "static/media/4_hole_button.5f121a89.png";